// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"428":"fcd51917","498":"fcd51917"}[chunkId] + ".chunk.css";
};